import { colorShade } from "./utils.js";

export const applyTheme = (lawyerConfig) => {
  const accentColor = lawyerConfig.accentColor;

  let root = document.documentElement;
  if (accentColor) {
    const lightAccentColor = colorShade(accentColor, 10);
    const darkAccentColor = colorShade(accentColor, -10);

    root.style.setProperty("--accent", accentColor);
    root.style.setProperty("--accent-light", lightAccentColor);
    root.style.setProperty("--accent-dark", darkAccentColor);
  }

  if (lawyerConfig.clientBackgroundImage) {
    root.style.setProperty(
      "--client-background-image",
      `url(${lawyerConfig.clientBackgroundImage})`,
    );
  }
};
